import { render, staticRenderFns } from "./Validations.vue?vue&type=template&id=1f68a828"
import script from "./Validations.vue?vue&type=script&lang=js"
export * from "./Validations.vue?vue&type=script&lang=js"
import style0 from "./Validations.vue?vue&type=style&index=0&id=1f68a828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports